import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import Recognition from "../fragments/Recognition"
import ScheduledGroupCelebrationFragment from "../fragments/ScheduledGroupCelebration"

const mutation = gql`
  mutation ToggleReaction($reaction: RecognitionFeedReactionInput!) {
    toggleReaction(reaction: $reaction) {
      recognition {
        ...recognitionFields
      }
      groupCelebration {
        ...ScheduledGroupCelebration
      }
    }
  }
  ${Recognition}
  ${ScheduledGroupCelebrationFragment}
`
export const toggleReactionMutationKey = getQueryNames(mutation)[0]

export default mutation
